import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

interface WithDynamicTitleProps {}

function withDynamicTitle<P>(
  WrappedComponent: React.ComponentType<P>,
  title: string
) {
  const WithDynamicTitle: React.FC<P & WithDynamicTitleProps> = (props) => {
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
      document.title = `${t(title, title)} - AiRentoSoft`;
    }, [location.pathname, title, t]);

    return <WrappedComponent {...props} />;
  };

  return WithDynamicTitle;
}

export default withDynamicTitle;
